<template>
	<div class="workbook">
		<div class="workbook--image">
			<img :src="image" alt="" />
		</div>
		<div class="workbook-info">
			<div class="workbook--title">{{ title }}</div>
			<div class="workbook--subtitle">{{ subtitle }}</div>
			<div v-if="price" class="workbook--price" v-html="price"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['title', 'subtitle', 'image', 'price']
}
</script>

<style lang="scss" scoped>
.workbook {
	display: flex;
	position: relative;
	background-color: #f0f0f3;
	border-radius: 1rem;

	&.mb-40 {
		margin-bottom: 30px;
	}

	&--image {
		position: absolute;
		width: 6.4rem;
		top: -1.6rem;
		left: 0.5rem;

		img {
			display: block;
		}
	}

	&-info {
		padding-left: 7.7rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		padding-right: 1rem;
	}

	&--title {
		font-weight: bold;
		font-size: 1.26rem;
	}

	&--subtitle {
		font-weight: 500;
		font-size: 1.16rem;
		line-height: 1.3rem;
		margin-top: 0.1rem;
		max-width: 90%;
	}

	&--price {
		font-weight: 500;
		font-size: 1.2rem;
		margin-top: 0.5rem;
	}

	&.active {
		border: 2px solid #eca58f;
		background-color: #fff9f8;
	}

	&.active & {
		&--subtitle {
			color: #eca58f;
		}
	}
}
</style>
